import THIRD_PARTY_TYPES from '@/components/jobs/JobForm/thirdPartyTypes';

export const pip_re = /^"?[a-zA-z0-9_\-<>.=:/@\n+[\]]*"?$/; //pip supports git repo installs
export const apt_re = /^"?[a-zA-z0-9_\-<>.=\n]*"?$/;

export const aws_re = /^[0-9a-z-.]*\.amazonaws.com\/.*$/;
export const docker_re = /^[0-9a-z]*\/[0-9a-z-_]*/;
export const gcp_re = /^[a-z.]*gcr.io\/.*$/;
export const gcp_new_re = /^[0-9a-zA-Z-.]*-docker.pkg.dev\/.*$/;
export const ngc_re = /^[a-z.]*nvcr.io\/.*$/;
export const azure_re = /^[0-9a-zA-Z]*.azurecr.io\/.*$/;
export const git_re = /^ghcr.io\/.*$/;

export const getImageType = (name) => {
  switch (true) {
    case aws_re.test(name):
      return THIRD_PARTY_TYPES.AWS.value;
    case gcp_re.test(name):
      return THIRD_PARTY_TYPES.GCP.value;
    case gcp_new_re.test(name):
      return THIRD_PARTY_TYPES.GCP.value;
    case ngc_re.test(name):
      return THIRD_PARTY_TYPES.NVIDIA.value;
    case docker_re.test(name):
      return THIRD_PARTY_TYPES.DOCKER.value;
    case azure_re.test(name):
      return THIRD_PARTY_TYPES.AZURE.value;
    case git_re.test(name):
      return THIRD_PARTY_TYPES.GIT.value;
    default:
      return;
  }
};

export const buildKeyOptions = (options, configured_keys) => {
  configured_keys = configured_keys || [];
  return options.map((option) => {
    const { alwaysEnabled, uriTest, uriExample, ...rest } = option;
    if (
      configured_keys.some((key) => key.type === option.key) ||
      alwaysEnabled
    ) {
      return rest;
    }
    return { disabled: true, ...rest };
  });
};

